export function watchBodyMutations(callback: () => void): () => void {
    const observer = new MutationObserver(callback)
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
    })

    return () => observer.disconnect()
}
